import fetcher, { initialize as setSRAConnect } from "../utils/fetcher";
import { InternalErrorAction } from "../actions/internalError";
import { store } from "../store";

let requestApi = () => Promise.reject(new Error("Uninitialized fetcher"));

/**
 * Initialize fetcher with required info.
 *
 * @param {string} url - Back-end url
 * @param {Object} connectInstance - Connect instance
 */
export function initialize({ url, connect }) {
	setSRAConnect(connect);

	requestApi = fetcher({
		connect,
		url,
		store
	});
}

/**
 * Perform an action over the network
 *
 * @param {Action} action - Action to perform
 */
export default function requestAction(action) {
	try {
		requestApi(action);
	} catch (err) {
		store.dispatch(new InternalErrorAction({ error: err }));
	}
}
